<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<dash-gis-flexible-panel panelTitle="Markup" width="300px">
    <div class="dash-gis-markup-panel-container" fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="column" fxLayoutGap="12px">
            <label>Choose a Markup Tool:</label>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <button mat-icon-button
                        matTooltip="Line"
                        [ngClass]="markupTool == 'line' ? 'md-primary' : ''"
                        (click)="setTool('line')">
                    <mat-icon svgIcon="draw-line" aria-label="Reports"></mat-icon>
                </button>
                <button mat-icon-button
                        matTooltip="Rectangle"
                        [ngClass]="markupTool == 'rect' ? 'md-primary' : ''"
                        (click)="setTool('rect')">
                    <mat-icon svgIcon="draw-rect" aria-label="Reports"></mat-icon>
                </button>
                <button mat-icon-button
                        matTooltip="Circle"
                        [ngClass]="markupTool == 'circle' ? 'md-primary' : ''"
                        (click)="setTool('circle')">
                    <mat-icon svgIcon="draw-circle" aria-label="Reports"></mat-icon>
                </button>
                <button mat-icon-button
                        matTooltip="Polygon"
                        [ngClass]="markupTool == 'polygon' ? 'md-primary' : ''"
                        (click)="setTool('polygon')">
                    <mat-icon svgIcon="draw-poly" aria-label="Reports"></mat-icon>
                </button>
                <button mat-icon-button
                        matTooltip="Text"
                        [ngClass]="markupTool == 'text' ? 'md-primary' : ''"
                        (click)="getMarkupText()">
                    <mat-icon svgIcon="draw-text" aria-label="Reports"></mat-icon>
                </button>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                <label>Choose the markup color:</label>
                <input type="color" [(ngModel)]="markupColor" />
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-button (click)="undo()" [disabled]="!hasFeatures">Undo</button>
            <button mat-button (click)="clear()" [disabled]="!hasFeatures">Clear</button>
            <button mat-button (click)="close()">Done</button>
        </div>
    </div>
</dash-gis-flexible-panel>
